// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".answer-wrapper[data-v-3119f3c2]{display:grid;grid-template-rows:0fr;overflow:hidden;transition:.3s}.answer-wrapper--active[data-v-3119f3c2]{grid-template-rows:1fr}.question-list[data-v-3119f3c2]{box-shadow:0 0 160px -40px rgba(253,108,67,.2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
